import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";

interface LocalStorageItem {
  key: string;
  value: string | null;
}

interface LocalStorageManagerProps {
  onClearAllStorage: () => void;
}

const LocalStorageManager: React.FC<LocalStorageManagerProps> = ({
  onClearAllStorage,
}) => {
  const [localStorageKey, setLocalStorageKey] = useState("");
  const [localStorageValue, setLocalStorageValue] = useState("");
  const [localStorageData, setLocalStorageData] = useState<LocalStorageItem[]>(
    Object.keys(localStorage).map((key) => ({
      key,
      value: localStorage.getItem(key),
    }))
  );

  const updateLocalStorageData = () => {
    setLocalStorageData(
      Object.keys(localStorage).map((key) => ({
        key,
        value: localStorage.getItem(key),
      }))
    );
  };

  const handleSetLocalStorage = () => {
    if (localStorageKey && localStorageValue) {
      localStorage.setItem(localStorageKey, localStorageValue);
      updateLocalStorageData();
      setLocalStorageKey("");
      setLocalStorageValue("");
    }
  };

  const handleRemoveLocalStorage = (key: string) => {
    localStorage.removeItem(key);
    updateLocalStorageData();
  };

  useEffect(() => {
    updateLocalStorageData();
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>💾 Local Storage Management</h4>
        <Button variant="danger" size="sm" onClick={onClearAllStorage}>
          Clear All Storage
        </Button>
      </div>

      <Form>
        <Row>
          <Col md={5}>
            <Form.Group controlId="localStorageKey">
              <Form.Label>Key</Form.Label>
              <Form.Control
                type="text"
                value={localStorageKey}
                onChange={(e) => setLocalStorageKey(e.target.value)}
                placeholder="Enter local storage key"
              />
            </Form.Group>
          </Col>
          <Col md={5}>
            <Form.Group controlId="localStorageValue">
              <Form.Label>Value</Form.Label>
              <Form.Control
                type="text"
                value={localStorageValue}
                onChange={(e) => setLocalStorageValue(e.target.value)}
                placeholder="Enter local storage value"
              />
            </Form.Group>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <Button variant="primary" onClick={handleSetLocalStorage}>
              Set
            </Button>
          </Col>
        </Row>
      </Form>

      <h5 className="mt-4">Local Storage Data</h5>
      <Table striped bordered hover responsive size="sm">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {localStorageData.map((item) => (
            <tr key={item.key}>
              <td style={{ fontWeight: "bold", fontFamily: "monospace" }}>{item.key}</td>
              <td
                style={{
                  maxWidth: "300px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontFamily: "monospace",
                  fontSize: "12px"
                }}
                title={item.value || ""}
              >
                {item.value}
              </td>
              <td>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleRemoveLocalStorage(item.key)}
                >
                  Remove
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default LocalStorageManager;